import axiosInstance from "app/axiosInstance";
import { ObjectForMapRequestDto } from "../entities/dtos/object-for-map-request.dto";

export const getObjectDataForMap = async (payload: ObjectForMapRequestDto) => {
  try {
    const { accountId, objectId } = payload;
    const response = await axiosInstance.get(
      `/accounts/${accountId}/objects/${objectId}/map`
    );

    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
